"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Entity = void 0;
var Field_1 = require("./Field");
var Entity = /** @class */ (function () {
    /** Construct an entity from a definition
     * @internal
     */
    function Entity(_definition) {
        this._definition = _definition;
    }
    /** Get a field
     * @param name The field's name; can be a nested name using the separator
     * @returns The field or null if not found
     */
    Entity.prototype.field = function (name) {
        var _a = __read(Field_1.Field.parseFieldName(name), 2), head = _a[0], tail = _a[1];
        var fieldDef = this._definition.field.find(function (e) { return e.name === head; });
        return fieldDef != null ? new Field_1.Field(fieldDef, this).field(tail) : null;
    };
    Object.defineProperty(Entity.prototype, "fields", {
        /** Get an array of all fields */
        get: function () {
            var _this = this;
            if (this._definition.field == null) {
                return null;
            }
            return this._definition.field.map(function (fieldDef) { return new Field_1.Field(fieldDef, _this); });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Entity.prototype, "name", {
        /** Get the name of this entity */
        get: function () {
            return this._definition.name;
        },
        enumerable: false,
        configurable: true
    });
    return Entity;
}());
exports.Entity = Entity;
